import {Material, MaterialType, useHistoryMaterialsById} from '@domain/materials'
import {CementIcon, ClinkerIcon, dataTestId} from '@hconnect/uikit'
import {Box, Skeleton, Stack, StackProps, Typography, SvgIconProps} from '@mui/material'
import {MomentRange, usePlanningChartStartEnd} from '@widgets/planning-schedule-chart'

import {OptimizerStockMillETAIndicator} from './OptimizerStockMillETAIndicator'

type OptimizerStockLevelInfoProps = {
  plantCode: string
  material: Material
} & StackProps

const iconStyle: SvgIconProps = {
  style: {
    marginRight: '4px'
  },
  height: '16px'
}
export const OptimizerStockLevelInfo = ({
  plantCode,
  material,
  ...restProps
}: OptimizerStockLevelInfoProps) => {
  const materialId = material.id

  const {startOfPlan, endOfPlan} = usePlanningChartStartEnd()
  const planTimeFrame: MomentRange = [startOfPlan, endOfPlan]
  const {data: materialsById} = useHistoryMaterialsById({
    plantId: plantCode,
    timeFrame: planTimeFrame
  })

  if (!materialsById) {
    return <Skeleton variant="rectangular" />
  }

  if (!material) {
    throw new Error(`Material ${materialId} not found`)
  }

  const icon =
    material.type === MaterialType.Cement ? (
      <CementIcon {...iconStyle} />
    ) : (
      <ClinkerIcon {...iconStyle} />
    )

  return (
    <Stack
      {...restProps}
      direction="row"
      alignItems="center"
      spacing={1}
      {...dataTestId('optimizer_stock_levels_info')}
    >
      <Box display="flex" alignItems="center">
        {icon} <Typography variant="body2">{material.name}</Typography>
      </Box>
      <Typography variant="caption" {...dataTestId('optimizer_stock_levels_mill_eta')}>
        <OptimizerStockMillETAIndicator plantCode={plantCode} material={material} />
      </Typography>
    </Stack>
  )
}
